import { renderReact } from 'hypernova-react'

export const makeHypernovaComponents = (components) => {
  return Object.entries(components).reduce((acc, [registerName, component]) => ({
    ...acc,
    [registerName]: renderReact(registerName, component),
  }), {})
}
